import React from "react";

declare const window: any;

const LegalText = ({ isLegalText, text, setIsLegalText }: any) => {
  return (
    <div className={`legal-text-container-external  ${isLegalText ? "show" : ""}`}>
      <div className={`legal-text-container`}>
        {text}
        <div className="legal-text-close" onClick={() => setIsLegalText(false)}>
          <i className="fas fa-xmark"></i>
        </div>
      </div>
    </div>
  );
};

export default LegalText;
